import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ComplianceTaskListPageUI from './ComplianceTaskListPageUI'

class ComplianceTaskListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      complianceTaskList: null,
    }
  }

  render() {
    return (
      <ComplianceTaskListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        complianceTaskList={this.state.complianceTaskList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    const { context } = this.props
    this.getComplianceTaskList(context)
  }

  getComplianceTaskList(context) {
    const cacheManager = new CacheManager({
      resource: '/api/su/compliances/tasks',
      cacheKey: CacheKeys.ComplianceTaskList(),
      callback: this.getComplianceTaskListCallback,
      ttlInSecs: 600,
    })
    cacheManager.getObject2(context)
  }

  getComplianceTaskListCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      complianceTaskList: response.taskList,
    })
  }

  onRefreshClick = () => {
    const { context } = this.props
    CacheManager.removeObject(CacheKeys.ComplianceTaskList())
    this.setState({
      errorList: null,
      complianceTaskList: null,
    })
    this.getComplianceTaskList(context)
  }
}

export default ComplianceTaskListPageSF
